// Company functions for AutoRegisterForm
// This file contains functions for handling company registration via email verification

// Get API_URL from environment variable, default to production URL if not set or .env file doesn't exist
const API_URL = process.env.REACT_APP_API_URL || 'https://app.egodziny.pl/api';

/**
 * Sends verification email via API
 * @param {Object} formData - The form data containing user and company information
 * @param {boolean} isResending - Whether this call is a resend attempt (default: false)
 * @returns {Promise<Object>} - API response
 */
export const sendVerificationEmail = async (formData, isResending = false) => {
    try {
        const APP_ID = process.env.REACT_APP_PUBLIC_ID;
        const response = await fetch(`${API_URL}/send_verification_email`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-EGODZINY-APP-ID': APP_ID,
            },
            body: JSON.stringify({
                company_name: formData.companyName,
                company_address: formData.companyAddress,
                company_nip: formData.nip,
                user_email: formData.email,
                user_name: formData.name,
                user_surname: formData.surname,
                user_phone: formData.phone,
                user_position: "-",
                accepted_terms: formData.acceptedTerms,
                recaptcha_token: formData.captchaToken,
                is_resending: isResending,
            })
        });
        
        // Always attempt to read body and propagate message
        const raw = await response.text().catch(() => '');
        let parsed;
        try {
            parsed = raw ? JSON.parse(raw) : {};
        } catch (_) {
            parsed = {};
        }

        if (!response.ok) {
            const message = parsed?.message || raw || `HTTP error! status: ${response.status}`;
            return {
                success: false,
                status: response.status,
                ...parsed,
                message: message,
                errors: parsed?.errors || []
            };
        }

        return {
            success: true,
            status: response.status,
            ...parsed
        };
        
    } catch (error) {
        console.error('Error sending verification email:', error);
        return {
            success: false,
            status: 0,
            message: error.message || 'Network error',
            errors: []
        };
    }
};

/**
 * Validates company data before submission
 * @param {Object} formData - The form data to validate
 * @returns {Object} - Validation result with isValid boolean and errors array
 */
export const validateCompanyData = (formData) => {
//   const errors = [];
  
//   // Basic validation examples
//   if (!formData.companyName || formData.companyName.trim().length < 2) {
//     errors.push('Company name must be at least 2 characters long');
//   }
  
//   if (!formData.nip || formData.nip.trim().length !== 10) {
//     errors.push('NIP must be exactly 10 digits');
//   }
  
//   if (!formData.email || !formData.email.includes('@') || !formData.email.includes('.')) {
//     errors.push('Valid email address is required');
//   }
  
//   return {
//     isValid: errors.length === 0,
//     errors
//   };
  return {
    isValid: true,
    errors: []
  };
};
